'use client'
import { Box, Image, Text } from '@mantine/core'
import { useTranslations } from 'next-intl'

import { useIsResponsiveMobileView } from '@/hooks/responsive'
import { formatUpToDecimals } from '@/utils/number'

import styles from './styles.module.css'

interface EarnCardProps {
  name?: string
  icon_url: string
  apr: string | number
}

export default function EarnCard({ name, icon_url, apr }: EarnCardProps) {
  const isMobile = useIsResponsiveMobileView()
  const t = useTranslations('earn')

  return (
    <Box
      className={styles.earnContainer}
      onClick={() => {
        window.open('https://crypto.com/earn', '_blank')
      }}
      p={16}
    >
      {/* Coin Info */}
      <Image src={icon_url} alt={name || t('card.coinAlt')} className={styles.coinIcon} mb={16} />
      <Text variant={isMobile ? 'body' : 'heading3'} truncate>
        {name || ''}
      </Text>

      {/* APR Info */}
      <Text variant={isMobile ? 'heading3' : 'heading2'}>
        {t('card.upTo')}{' '}
        <Text component="span" c="var(--common-success)" fw={600}>
          {formatUpToDecimals(Number(apr) * 100, 2)}%
        </Text>{' '}
        {t('card.perAnnum')}
      </Text>
    </Box>
  )
}
